import { format, addDays, subDays, endOfDay, differenceInDays, addHours, formatDistance } from 'date-fns';
import { nb } from 'date-fns/locale';
import * as yup from 'yup';

export const formatNorwegianDate = (date: Date | string, formatStr: string = 'MMMM do yyyy'): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return format(dateObj, formatStr, { locale: nb });
};

export const formatDate = (date: Date | string | null, formatStr: string = 'yyyy-MM-dd'): string => {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return format(dateObj, formatStr);
};

export const formatDateTime = (date: Date | string | null, formatStr: string = 'yyyy-MM-dd HH:mm:ss'): string => {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return format(dateObj, formatStr);
};

export const addDaysToDate = (date: Date | string, days: number): Date => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return addDays(dateObj, days);
};

export const subtractDays = (date: Date | string, days: number): Date => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return subDays(dateObj, days);
};

export const getEndOfDay = (date: Date | string): Date => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return endOfDay(dateObj);
};

export const getDifferenceInDays = (dateLeft: Date | string, dateRight: Date | string): number => {
  const leftObj = typeof dateLeft === 'string' ? new Date(dateLeft) : dateLeft;
  const rightObj = typeof dateRight === 'string' ? new Date(dateRight) : dateRight;
  return differenceInDays(leftObj, rightObj);
};

export const addHoursToDate = (date: Date | string, hours: number): Date => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return addHours(dateObj, hours);
};

export const buildYupTimeDateProperty = (
  propertyName: string,
  min: boolean,
  max: boolean,
  daysToAdd?: number,
  daysToSubtract?: number
) => {
  const schemaProperty = yup
    .date()
    .transform(function (value, originalValue) {
      if (this.isType(value)) {
        return value;
      }
      return new Date(originalValue);
    })
    .typeError('Please enter a valid date!')
    .required(`${propertyName} is required!`);

  if (min && daysToSubtract) {
    schemaProperty.min(subDays(new Date(), daysToSubtract), `${propertyName} must be in the future!`);
  }

  if (max && daysToAdd) {
    schemaProperty.max(addDays(new Date(), daysToAdd), `${propertyName} must be in the past!`);
  }

  return schemaProperty;
};
